import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const BoldIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uE238'}</MuiIcon>
        );
    })